import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { SignaturePad } from "@/components/SignaturePad";
import { PenLine } from "lucide-react";

const errMsg = (e) => e?.response?.data?.detail || "Something went wrong";

const getGeo = () => new Promise((resolve) => {
  if (!navigator.geolocation) return resolve({ geo_status: "unsupported" });
  navigator.geolocation.getCurrentPosition(
    (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, geo_status: "granted" }),
    (e) => resolve({ geo_status: e.code === 1 ? "denied" : "unavailable" }),
    { enableHighAccuracy: true, timeout: 8000 },
  );
});

export const ConsentESign = ({ onDone }) => {
  const [agree, setAgree] = useState(false);
  const [name, setName] = useState("");
  const [sig, setSig] = useState("");
  const [busy, setBusy] = useState(false);
  const ready = agree && name.trim().length >= 3 && !!sig;

  const sign = async () => {
    setBusy(true);
    try {
      const geo = await getGeo();
      await api.post("/suspension/respond", { decision: "continue", agree, signature_name: name, signature_image: sig, ...geo });
      toast.success("Thank you — your e-signature has been recorded.");
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-3" data-testid="consent-esign">
      <label className="flex items-start gap-2 text-sm text-slate-700">
        <Checkbox checked={agree} onCheckedChange={(x) => setAgree(!!x)} data-testid="consent-agree-checkbox" className="mt-0.5" />
        I have read and understood this document and agree to the terms expressly stated in it.
      </label>
      <Input placeholder="Your full name" value={name} onChange={(e) => setName(e.target.value)} data-testid="consent-signature-input" />
      <SignaturePad onChange={setSig} testId="consent-signature-pad" />
      <Button disabled={busy || !ready} onClick={sign} className="w-full bg-navy text-gold hover:bg-navy/90" data-testid="consent-submit-continue">
        <PenLine className="mr-2 h-4 w-4" />E-sign &amp; Submit
      </Button>
      <p className="text-[11px] text-slate-500">Your signature, date &amp; time, device, IP address and location (if allowed) are recorded on the signed copy.</p>
    </div>
  );
};
